export const fetchBookstore = async (termCode, crn) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    const url = `${apiUrl}/getbook`;
    const options = {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
            bookstoreId: 2082,
            courses: [{ courseRefId: crn }],
            termId: termCode
        })
    };

    try {
        const response = await fetch(url, options);
        const data = await response.json();
        const section = data[0]?.courseSectionDTO?.[0];

        if (section?.courseSectionStatus?.status === 'FAIL') {
            return 'No Text Book';
        }
        const material = section?.courseMaterialResultsList?.[0];
        return {
            title: material?.title,
            edition: material?.edition,
            author: material?.author,
            link: `https://www.bkstr.com/webApp/discoverView?bookstore_id-1=2082&term_id-1=${termCode}&crn-1=${crn}`,
            publisher: material?.publisher
        };
    } catch (error) {
        console.error(error);
        return 'Error fetching bookstore info';
    }
}